import React from 'react';
import HeroInlineMarketingCta from 'components/Hero/HeroInlineMarketingCta';
import MarketingProHeroHTML5Video from './MarketingProHeroHTML5Video';
import Text from 'components/Text';
import WistiaVideo from 'components/WistiaVideo';

import { Container } from './styles';

const MarketingProHero = ({ form, title, description, isMobile, type, video }) => {
  return (
    <Container>
      <div className="marketing-pro-hero--inner-container">
        <div
          className={`marketing-pro-hero--copy-${
            type === 'video-bottom' ? 'video-bottom' : 'video-right'
          }`}
        >
          <Text type="h1" className="marketing-pro-hero--title" color="white">
            {title}
          </Text>
          <Text
            type="p"
            color="white"
            marginBottom="80px"
            className="marketing-pro-hero--sub-title"
          >
            {description}
          </Text>
          {type === 'video-right' && isMobile && (
            <div className="marketing-pro-hero--video-right">
              <WistiaVideo {...video} wrapperStyles={{ height: '50vw' }} />
            </div>
          )}
          <HeroInlineMarketingCta
            buttonLabel="Get Started"
            buttonType="secondary"
            data={form}
            fullWidth
            className={`marketing-pro-hero--form-${type === 'video' ? 'video' : 'image'}`}
          />
        </div>
        {type === 'video-right' && !isMobile && (
          <div className="marketing-pro-hero--video-right">
            <WistiaVideo {...video} wrapperStyles={{ height: '380px' }} />
          </div>
        )}
      </div>
      {type === 'video-bottom' && <MarketingProHeroHTML5Video />}
    </Container>
  );
};

export default MarketingProHero;
